'use strict';

const BaseScene = require('./base-scene');
const Button = require('../ui/button');
const { COLORS, GAME_WIDTH } = require('../config/constants');
const { drawGlowText, drawText, drawPanel } = require('../ui/draw');

class DailyChallengesScene extends BaseScene {
  enter() {
    this.loading = true;
    this.error = '';
    this.dashboard = this.app.dashboard;
    this.buttons = [new Button({
      x: 235, y: 1180, width: 280, height: 82, label: '返回首页', variant: 'secondary',
      onTap: () => this.app.switchScene('home')
    })];
    this.app.refreshDashboard().then((dashboard) => {
      this.dashboard = dashboard;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
      this.error = '网络不可用，显示上次同步内容';
    });
  }

  render(ctx) {
    drawGlowText(ctx, '每日挑战', GAME_WIDTH / 2, 135, 58, COLORS.cyan);
    drawText(ctx, '每日 0 点自动刷新 · 完成后自动领取经验', GAME_WIDTH / 2, 205, 24, COLORS.muted);
    const tasks = (this.dashboard && this.dashboard.dailyChallenges) || [];
    if (!tasks.length) {
      drawText(ctx, this.loading ? '正在同步挑战…' : '暂无挑战数据', GAME_WIDTH / 2, 520, 30, COLORS.muted);
    }
    tasks.slice(0, 3).forEach((task, index) => {
      const y = 285 + index * 245;
      const done = Boolean(task.completedAt) || Number(task.currentValue) >= Number(task.targetValue);
      drawPanel(ctx, 70, y, 610, 190, { stroke: done ? COLORS.success : 'rgba(70,230,255,.35)' });
      drawText(ctx, task.title, 105, y + 48, 29, COLORS.text, 'left', 'bold');
      drawText(ctx, `${Math.min(task.currentValue, task.targetValue)} / ${task.targetValue}`, 105, y + 105, 26, done ? COLORS.success : COLORS.cyan, 'left', 'bold');
      drawText(ctx, done ? '已完成' : `奖励 +${task.rewardXp} XP`, 640, y + 105, 24, done ? COLORS.success : COLORS.warning, 'right');
      const ratio = Math.max(0, Math.min(1, Number(task.currentValue) / Number(task.targetValue)));
      ctx.fillStyle = 'rgba(145,164,201,.18)'; ctx.fillRect(105, y + 145, 540, 12);
      ctx.fillStyle = done ? COLORS.success : COLORS.cyan; ctx.fillRect(105, y + 145, 540 * ratio, 12);
    });
    if (this.error) drawText(ctx, this.error, GAME_WIDTH / 2, 1095, 22, COLORS.warning);
    this.drawButtons(ctx);
  }
}

module.exports = DailyChallengesScene;
